<template>
  <div
    class="overlay pointer"
    :class="{ overlay_visible: isOverlayVisible, overlay_fullscreen: isOverlayFullscreen }"
    @click="$emit('onOverlayClicked')"
  ></div>
</template>

<script>
  import { useMainStore } from '@/stores/main';
  import { storeToRefs } from 'pinia';

  export default {
    props: {
      isOverlayVisible: {
        type: Boolean,
        default: false
      },
      isOverlayFullscreen: {
        type: Boolean,
        default: false
      }
    },
    setup() {
      const mainStore = useMainStore();
      const { sidebarState } = storeToRefs(mainStore);
      return { sidebarState };
    },
    watch: {
      isOverlayVisible(value) {
        const bodyEl = document.body;
        if (value) {
          bodyEl.classList.add('overlay-opened');
        } else {
          bodyEl.classList.remove('overlay-opened');
        }
      }
    }
  };
</script>
